<app-bar-chart 
    [data]="data" 
    [width]="900" 
    [stacks]="['Number of warnings']"
    [height]="400"
    (selectNodeEvent)="handleBarSelection($event)">
</app-bar-chart>
